import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagTurnoFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagTurno'>
      {({ field }) => <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagTurno' label='Uso Turnos' />}
    </Field>
  )
}

export default React.memo(FlagTurnoFormGroup)
